const trainingCategories = [
  { label: 'New Advisor Training', value: 'new_advisor_training' },
  { label: 'Leadership Training', value: 'leadership_training' },
  { label: 'Sales Concept', value: 'sales_concept' },
  { label: 'Others', value: 'others' },
];

export { trainingCategories };
